export const storageKey = {
  user: "user",
  userTableColumns: "userTableColumns",
  token: "token",
} as const;
